import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import { useAxiosWithAuthorization } from "../../../utils/api";
import useAppContext from "../../../utils/Reducers";

const VenderInfoPop = ({ vndrCd }) => {
  //공급업체 검색 URL
  const SERARCH_VENDOR_URL = "/company/searchVendorInfo.do";
  //console.log(vndrCd);
  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_VENDOR_URL,
    },
    { manual: true }
  );
  const initItem = {
    systemCd: "",
    vndrCd: "",
    vndrNm: "",
    addr: "",
    addrDesc: "",
    latt: "",
    lont: "",
    bsnsNo: "",
    telNo: "",
    mngrNm: "",
    mngrTel: "",
    vndrTypeCd: "",
    vndrTypeCdNm: "",
    profNeedYn: "",
    erpId: "",
    useYn: "",
    note: "",
  };
  const [fieldValues, setFieldValues] = useState(initItem);
  const [show, setShow] = useState(true);
  const {
    store: { userInfo },
  } = useAppContext();

  const handleClose = (returnData) => {
    setShow(false);
  };

  const handleOk = (returnData) => {
    setShow(false);
  };

  const handleSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      params: {
        schVndrCd: vndrCd,
      },
    });

    //console.log(data);
    setFieldValues(data[0]);
  };

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    handleSearch();
    //
  }, []);

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)}>
        <Modal.Header closeButton>
          <Modal.Title>공급업체정보</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="searchdata">
            <table className="t_garo">
              <tr>
                <th>사업자번호</th>
                <td style={{ width: "200px" }}>{fieldValues?.bsnsNo}</td>
                <th>공급업체명</th>
                <td style={{ width: "200px" }}>{fieldValues?.vndrNm}</td>
              </tr>
              <tr>
                <th>전화번호</th>
                <td style={{ width: "200px" }}>{fieldValues?.telNo}</td>
                <th>관리자</th>
                <td style={{ width: "200px" }}>{fieldValues?.mngrNm}</td>
              </tr>
              <tr>
                <th>관리자전화번호</th>
                <td style={{ width: "200px" }}>{fieldValues?.mngrTel}</td>
                <th>업체유형</th>
                <td style={{ width: "200px" }}>{fieldValues?.vndrTypeCdNm}</td>
              </tr>
              <tr>
                <th>주소1</th>
                <td style={{ width: "200px" }}>{fieldValues?.addr}</td>
                <th>주소2</th>
                <td style={{ width: "200px" }}>{fieldValues?.addrDesc}</td>
              </tr>
              <tr>
                <th>증빙필요여부</th>
                <td style={{ width: "200px" }}>{fieldValues?.profNeedYn}</td>
                <th>ERP아이디</th>
                <td style={{ width: "200px" }}>{fieldValues?.erpId}</td>
              </tr>
              <tr>
                <th>비고</th>
                <td style={{ width: "200px" }}>{fieldValues?.note}</td>
              </tr>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalVenderInfoPop = createModal(VenderInfoPop);

export default VenderInfoPop;
